import { useEffect, useState } from "react";
import { api } from "../../api/api";
import { NavBar } from "../../components/NavBar";
import { Toast } from "../../utils/Toast";
import { TypePayment } from "../../utils/utils";
import { FiCreditCard } from "react-icons/fi";
import '../admin.css'
import './style.css'

const cards = [
  {
    title: "Cartão de Crédito",
    type: "isCardCredit",
    list: [
      "Elo",
      "Visa",
      "MasterCard",
      "American Express",
      "Diners",
      "Hipercard",
      "Goodcard",
      "Verdecard",
      "Sorocred",
      "Credishop",
      "Banricocompras",
    ],
  },
  {
    title: "Cartão de Débito",
    type: "isCardDebit",
    list: ["Visa", "Elo", "MasterCard", "Banricocompras"],
  },
  {
    title: "Vales",
    type: "isVale",
    list: [
      "Alelo Alimentação",
      "Alelo Refeição",
      "Ben Visa Vale",
      "Cooper Card",
      "Credi Refeição",
      "Green Card",
      "PlanVale",
      "Refeisul",
      "Sodexo",
      "Sodexo Alimentação",
      "Ticked Restaurante",
      "Up Brasil",
      "VR Alimentação",
      "VR Refeição",
      "Vale Card",
      "VeroCard",
      "VeroCheque",
      "VR Smart",
    ],
  },
  {
    title: "Formas de pagamento aceitas",
    type: "money-and-pix",
    list: [
      TypePayment.money,
      TypePayment.card_credit,
      TypePayment.card_debit,
      TypePayment.pix,
      TypePayment.vale,
      // "Pagamento Online"
    ],
  },
];

export function PaymentMethodPage() {
  const [state, setState] = useState({
    id: null,
    isCardDebit: false,
    isCardCredit: false,
    isVale: false,
    isMoney: false,
    isPix: false,
    isOnline: false,
    data: {
      name: "",
      typeKey: "telefone",
      key: "",
    },
  });

  const [listCards, setLisCards] = useState([]);

  const [loading, setLoading] = useState(true);

  async function selectCard(name, active, key) {
    await api.post("/cards", {
      name,
      [key]: active,
      active: active,
    });
  }

  async function selectPaymentMethod(value, key, toast = true) {
    const data = {
      [key]: value,
    };

    await api.post("/payment-method", data);
    if (toast) Toast.success();
  }

  async function find() {
    const response = await api.get("/payment-method");
    if (response?.data?.id) {
      setState({
        ...response.data,
        data: response.data.data,
        isCardCredit: Boolean(response.data.isCardCredit),
        isCardDebit: Boolean(response.data.isCardDebit),
        isVale: Boolean(response.data.isVale),
        isMoney: Boolean(response.data.isMoney),
        isPix: Boolean(response.data.isPix),
        isOnline: Boolean(response.data.isOnline),
      });
    }
  }

  async function findCards() {
    const response = await api.get("/cards");
    setLisCards(response.data.data);
  }

  useEffect(() => {
    (async () => {
      await find();
      await findCards();
      setLoading(false);
    })();
  }, []);

  return (
    <>
      <NavBar>
        <main className="admin-page payment-method-page">
          <header className="admin-page-header"><div><h1>Formas de pagamento</h1><p>Defina os meios e bandeiras aceitos pela loja</p></div></header>
          <div>
            {loading === true && (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}

            {loading === false && (
              <>
                {cards.map((card) => {
                  return (
                    <section
                      className="admin-surface payment-config-card"
                      key={card.title}
                    >
                      <div className="card-body">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-around",
                            alignItems: "center",
                          }}
                        >
                          <div className="payment-card-copy" style={{ textAlign: "center" }}>
                            <p style={{ fontSize: "var(--font-size-section-title)" }}>{card.title}</p>
                            <p style={{ fontSize: "var(--font-size-subtitle)", color: "#666" }}>
                              Selecione as opções disponíveis
                            </p>
                          </div>
                          <div>
                            <div className="payment-options-grid"
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr 1fr",
                                gap: 20,
                                justifyContent: "start",
                              }}
                            >
                              {card.list.map((item, indexCard) => {
                                let checked = false;

                                if (card.type === "money-and-pix") {
                                  if (item === TypePayment.card_credit && state.isCardCredit) {
                                    checked = true;
                                  }

                                  if (item === TypePayment.card_debit && state.isCardDebit) {
                                    checked = true;
                                  }

                                  if (item === TypePayment.pix && state.isPix) {
                                    checked = true;
                                  }

                                  if (item === TypePayment.money && state.isMoney) {
                                    checked = true;
                                  }

                                  if (item === TypePayment.vale && state.isVale) {
                                    checked = true;
                                  }

                                  if (
                                    item === "Pagamento Online" &&
                                    state.isOnline
                                  ) {
                                    checked = true;
                                  }

                                } else {
                                  const data = listCards.find(
                                    (e) => e.name === item
                                  );

                                  if (
                                    card.type === "isCardCredit" &&
                                    data &&
                                    item === data.name &&
                                    Boolean(data.isCredit)
                                  ) {
                                    checked = true;
                                  }

                                  if (
                                    card.type === "isCardDebit" &&
                                    data &&
                                    item === data.name &&
                                    Boolean(data.isDebit)
                                  ) {
                                    checked = true;
                                  }

                                  if (
                                    card.type === "isVale" &&
                                    data &&
                                    item === data.name &&
                                    Boolean(data.isVoucher)
                                  ) {
                                    checked = true;
                                  }
                                }

                                return (
                                  <label className={`payment-option ${checked ? 'selected' : ''}`} key={indexCard}>
                                    <input
                                      onChange={(e) => {
                                        if (card.type === "isCardCredit") {
                                          selectCard(
                                            item?.name ?? item,
                                            e.target.checked,
                                            "isCredit"
                                          );

                                          setLisCards(
                                            listCards.map((value) => {
                                              if (
                                                value.name ===
                                                (item?.name || item)
                                              ) {
                                                return {
                                                  ...value,
                                                  isCredit: e.target.checked,
                                                };
                                              }
                                              return value;
                                            })
                                          );
                                        }

                                        if (card.type === "isCardDebit") {
                                          selectCard(
                                            item?.name ?? item,
                                            e.target.checked,
                                            "isDebit"
                                          );
                                          setLisCards(
                                            listCards.map((value) => {
                                              if (
                                                value.name ===
                                                (item?.name || item)
                                              ) {
                                                return {
                                                  ...value,
                                                  isDebit: e.target.checked,
                                                };
                                              }
                                              return value;
                                            })
                                          );
                                        }

                                        if (card.type === "isVale") {
                                          selectCard(
                                            item?.name ?? item,
                                            e.target.checked,
                                            "isVoucher"
                                          );
                                          setLisCards(
                                            listCards.map((value) => {
                                              if (
                                                value.name ===
                                                (item?.name || item)
                                              ) {
                                                return {
                                                  ...value,
                                                  isVoucher: e.target.checked,
                                                };
                                              }
                                              return value;
                                            })
                                          );
                                        }

                                        if (card.type === "money-and-pix") {
                                          if (item === "Dinheiro") {
                                            selectPaymentMethod(
                                              e.target.checked,
                                              "isMoney"
                                            );
                                            setState((value) => {
                                              return {
                                                ...value,
                                                isMoney: e.target.checked,
                                              };
                                            });
                                          }

                                          if (item === "PIX") {
                                            selectPaymentMethod(
                                              e.target.checked,
                                              "isPix"
                                            );
                                            setState((value) => {
                                              return {
                                                ...value,
                                                isPix: e.target.checked,
                                              };
                                            });
                                          }

                                          if (item === "Cartão Crédito") {
                                            selectPaymentMethod(
                                              e.target.checked,
                                              "isCardCredit"
                                            );
                                            setState((value) => {
                                              return {
                                                ...value,
                                                isCardCredit: e.target.checked,
                                              };
                                            });
                                          }

                                          if (item === "Cartão Débito") {
                                            selectPaymentMethod(
                                              e.target.checked,
                                              "isCardDebit"
                                            );
                                            setState((value) => {
                                              return {
                                                ...value,
                                                isCardDebit: e.target.checked,
                                              };
                                            });
                                          }

                                          if (item === "Vale") {
                                            selectPaymentMethod(
                                              e.target.checked,
                                              "isVale"
                                            );
                                            setState((value) => {
                                              return {
                                                ...value,
                                                isVale: e.target.checked,
                                              };
                                            });
                                          }

                                          // if (item === "Pagamento Online") {
                                          //   selectPaymentMethod(
                                          //     e.target.checked,
                                          //     "isOnline"
                                          //   );
                                          //   setState((value) => {
                                          //     return {
                                          //       ...value,
                                          //       isOnline: e.target.checked,
                                          //     };
                                          //   });
                                          // }
                                        }
                                      }}
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={checked}
                                      id={`${item}-${card.type ?? 1}`}
                                    />
                                    <span>{item?.name ?? item}</span>
                                  </label>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  );
                })}

                <div
                  className="admin-surface pix-config-card animate mb-5"
                  style={{ display: Boolean(state.isPix) ? "block" : "none" }}
                >
                  <div className="admin-surface-header"><div><h2>Configuração do PIX</h2><p>Informe a chave que será exibida ao cliente</p></div><FiCreditCard /></div>
                  <div className="pix-key-types" style={{ display: "flex", gap: 10 }}>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        onChange={(e) =>
                          setState({
                            ...state,
                            data: { ...state.data, typeKey: "telefone" },
                          })
                        }
                        checked={state.data?.typeKey === "telefone"}
                        name="flexRadioDefault"
                        id="telefone"
                      />
                      <label className="form-check-label" htmlFor="telefone">
                        Telefone
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        onChange={(e) =>
                          setState({
                            ...state,
                            data: { ...state.data, typeKey: "email" },
                          })
                        }
                        checked={state.data?.typeKey === "email"}
                        name="flexRadioDefault"
                        id="email"
                      />
                      <label className="form-check-label" htmlFor="email">
                        E-mail
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        onChange={(e) =>
                          setState({
                            ...state,
                            data: { ...state.data, typeKey: "cpf" },
                          })
                        }
                        checked={state.data?.typeKey === "cpf"}
                        name="flexRadioDefault"
                        id="cpf"
                      />
                      <label className="form-check-label" htmlFor="cpf">
                        CPF
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        onChange={(e) =>
                          setState({
                            ...state,
                            data: { ...state.data, typeKey: "cnpj" },
                          })
                        }
                        checked={state.data?.typeKey === "cnpj"}
                        name="flexRadioDefault"
                        id="cnpj"
                      />
                      <label className="form-check-label" htmlFor="cnpj">
                        CNPJ
                      </label>
                    </div>
                  </div>
                  <div className="pix-form">
                    <div className="mb-3">
                      <label htmlFor="nome" className="form-label">
                        Nome
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="nome"
                        value={state.data?.name}
                        onChange={(e) =>
                          setState({
                            ...state,
                            data: { ...state.data, name: e.target.value },
                          })
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="chave" className="form-label">
                        Chave
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="chave"
                        value={state.data?.key}
                        onChange={(e) =>
                          setState({
                            ...state,
                            data: { ...state.data, key: e.target.value },
                          })
                        }
                      />
                    </div>

                    <button className="admin-primary-button"
                      onClick={() => selectPaymentMethod(state.data, "data")}
                    >
                      Salvar informações
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </main>
      </NavBar>
    </>
  );
}
